import {getSecurityToken, saveFileInfo} from '@/api/common/ossFile'
import {getFileSuffix} from '@/utils/function'
import {guid} from '@/utils/global/function'
import {parseTime} from '@/utils/format/date'
import AliOSS from 'ali-oss'

const oss = {

  /**
   * 生成对象key
   */
  generateKey(accessPath, file, uuid) {
    let suffix = getFileSuffix(file.name)
    let date = parseTime(new Date(), '/{y}/{m}/')
    return `${accessPath}${date}${uuid}${suffix}`
  },

  /**
   * 获取临时授权访问
   */
  async getSecurityToken() {
    try {
      let resp = await getSecurityToken()
      let respData = resp.data
      if (respData && respData.code === 0) {
        return respData.data
      }
    } catch (e) {
      console.log(e)
    }
  },

  /**
   * 分片上传
   * https://help.aliyun.com/document_detail/64047.html#title-vbx-3di-xnh
   */
  async upload(file) {
    let stsData = await this.getSecurityToken()
    let config = {
      // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
      region: stsData.region,
      // 从STS服务获取的临时访问凭证。临时访问凭证包括临时访问密钥（AccessKeyId和AccessKeySecret）和安全令牌（SecurityToken）。
      accessKeyId: stsData.accessKeyId,
      accessKeySecret: stsData.accessKeySecret,
      stsToken: stsData.securityToken,
      // 填写Bucket名称。
      bucket: stsData.bucket,
      secure: true
    }

    let uuid = guid()
    let key = this.generateKey(stsData.accessPath, file, uuid)
    let client = new AliOSS(config)
    try {
      // 填写Object完整路径。Object完整路径中不能包含Bucket名称。
      // 您可以通过自定义文件名（例如exampleobject.txt）或目录（例如mytestdoc/exampleobject.txt）的形式实现将文件上传到当前Bucket或Bucket中的指定目录。
      let result = await client.multipartUpload(key, file)
      let form = {
        fileUuid: uuid,
        fileName: file.name,
        objectKey: result.name,
        fileUrl: result.res.requestUrls[0].split('?')[0],
        bucketName: stsData.bucket
      }
      return await this.saveFileInfo(form)
    } catch (e) {
      console.log(e)
    }
  },

  /**
   * 保存文件信息
   */
  async saveFileInfo(fileInfo) {
    try {
      let resp = await saveFileInfo(fileInfo)
      let respData = resp.data
      if (respData && respData.code === 0) {
        return respData.data
      }
    } catch (e) {
      console.log(e)
    }
  }

}

export default oss



// WEBPACK FOOTER //
// ./src/utils/file/oss.js